import { EventEmitter } from '@angular/core';
var HomeWorkSocialTab = (function () {
    function HomeWorkSocialTab() {
        this.onTabIndex = new EventEmitter();
    }
    HomeWorkSocialTab.prototype.ngOnInit = function () {
    };
    HomeWorkSocialTab.prototype.ngAfterViewInit = function () {
        if (this.tabNum == 0) {
            $("#slide").addClass("left");
        }
        else if (this.tabNum == 1) {
            $("#slide").addClass("right");
        }
    };
    HomeWorkSocialTab.prototype.tab = function (i) {
        this.onTabIndex.emit(i);
        this.tabNum = i;
        $("#slide").removeClass("left");
        $("#slide").removeClass("right");
        if (i === 0) {
            $("#slide").addClass("slide0");
            $("#slide").removeClass("slide1");
        }
        else if (i === 1) {
            $("#slide").addClass("slide1");
            $("#slide").removeClass("slide0");
        }
    };
    return HomeWorkSocialTab;
}());
export { HomeWorkSocialTab };



// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-social-tab/tab.ts.pre-build-optimizer.js